export default function checkIsMobile() {
    const userAgent = window.navigator.userAgent;
    return userAgent.toLowerCase().includes("mobi");
}
